module.exports = __webpack_public_path__ + "img/1111.8c62df1c.svg";